__turbopack_context__.v({
  "active": "Search-module-scss-module__eiOlMq__active",
  "articleRow": "Search-module-scss-module__eiOlMq__articleRow",
  "articleRowBody": "Search-module-scss-module__eiOlMq__articleRowBody",
  "articleRowIcon": "Search-module-scss-module__eiOlMq__articleRowIcon",
  "articleRowMeta": "Search-module-scss-module__eiOlMq__articleRowMeta",
  "articleRowTitle": "Search-module-scss-module__eiOlMq__articleRowTitle",
  "backdrop": "Search-module-scss-module__eiOlMq__backdrop",
  "categoryChip": "Search-module-scss-module__eiOlMq__categoryChip",
  "categoryChipIcon": "Search-module-scss-module__eiOlMq__categoryChipIcon",
  "container": "Search-module-scss-module__eiOlMq__container",
  "dropdown": "Search-module-scss-module__eiOlMq__dropdown",
  "footerCta": "Search-module-scss-module__eiOlMq__footerCta",
  "footerCtaLabel": "Search-module-scss-module__eiOlMq__footerCtaLabel",
  "highlight": "Search-module-scss-module__eiOlMq__highlight",
  "keywordWrapper": "Search-module-scss-module__eiOlMq__keywordWrapper",
  "listItemDate": "Search-module-scss-module__eiOlMq__listItemDate",
  "listItemDescription": "Search-module-scss-module__eiOlMq__listItemDescription",
  "listItemInfo": "Search-module-scss-module__eiOlMq__listItemInfo",
  "listItemLogo": "Search-module-scss-module__eiOlMq__listItemLogo",
  "listItemLogoImage": "Search-module-scss-module__eiOlMq__listItemLogoImage",
  "listItemSubtitle": "Search-module-scss-module__eiOlMq__listItemSubtitle",
  "listItemTitle": "Search-module-scss-module__eiOlMq__listItemTitle",
  "listItemWrapper": "Search-module-scss-module__eiOlMq__listItemWrapper",
  "negative": "Search-module-scss-module__eiOlMq__negative",
  "noResultsText": "Search-module-scss-module__eiOlMq__noResultsText",
  "positive": "Search-module-scss-module__eiOlMq__positive",
  "resultListItem": "Search-module-scss-module__eiOlMq__resultListItem",
  "resultWrapper": "Search-module-scss-module__eiOlMq__resultWrapper",
  "resultsWrapper": "Search-module-scss-module__eiOlMq__resultsWrapper",
  "searchBackdropFadeIn": "Search-module-scss-module__eiOlMq__searchBackdropFadeIn",
  "sectionHeader": "Search-module-scss-module__eiOlMq__sectionHeader",
  "sectionHeaderCount": "Search-module-scss-module__eiOlMq__sectionHeaderCount",
  "sectionHeaderLabel": "Search-module-scss-module__eiOlMq__sectionHeaderLabel",
  "sectionTitle": "Search-module-scss-module__eiOlMq__sectionTitle",
  "shortDate": "Search-module-scss-module__eiOlMq__shortDate",
  "symbolPill": "Search-module-scss-module__eiOlMq__symbolPill",
  "symbolPillChange": "Search-module-scss-module__eiOlMq__symbolPillChange",
  "symbolPillList": "Search-module-scss-module__eiOlMq__symbolPillList",
  "symbolPillLogo": "Search-module-scss-module__eiOlMq__symbolPillLogo",
  "symbolPillPrice": "Search-module-scss-module__eiOlMq__symbolPillPrice",
  "symbolPillPriceSkeleton": "Search-module-scss-module__eiOlMq__symbolPillPriceSkeleton",
  "symbolPillShimmer": "Search-module-scss-module__eiOlMq__symbolPillShimmer",
  "symbolPillSkeleton": "Search-module-scss-module__eiOlMq__symbolPillSkeleton",
  "symbolPillTitle": "Search-module-scss-module__eiOlMq__symbolPillTitle",
  "symbolRow": "Search-module-scss-module__eiOlMq__symbolRow",
  "symbolRowBody": "Search-module-scss-module__eiOlMq__symbolRowBody",
  "symbolRowChangePercent": "Search-module-scss-module__eiOlMq__symbolRowChangePercent",
  "symbolRowExchange": "Search-module-scss-module__eiOlMq__symbolRowExchange",
  "symbolRowLogo": "Search-module-scss-module__eiOlMq__symbolRowLogo",
  "symbolRowName": "Search-module-scss-module__eiOlMq__symbolRowName",
  "symbolRowPrice": "Search-module-scss-module__eiOlMq__symbolRowPrice",
  "symbolRowTitle": "Search-module-scss-module__eiOlMq__symbolRowTitle",
  "trendingIcon": "Search-module-scss-module__eiOlMq__trendingIcon",
  "trendingKeywordItem": "Search-module-scss-module__eiOlMq__trendingKeywordItem",
  "wrapper": "Search-module-scss-module__eiOlMq__wrapper",
});
